'use strict';

/**
 * @classname Modal
 * @classdesc モーダル
 */
export default class Modal {
	/**
	 * @constructor
	 * @param {jQuery} $e - [data-toggle=modal]
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._target = $e.attr('data-target');
		this._$target = $(this._target);
		this._imageUrlSp = $e.data('image-url-sp');
		this._imageUrlPc = $e.data('image-url-pc');
		this._logoUrl = $e.data('logo-url');
		this._nameJa = $e.data('name-ja');
		this._nameEn = $e.data('name-en');
		this._address = $e.data('address');
		this._establishment = $e.data('establishment');
		const coeducation = $e.data('coeducation');
		if(coeducation == '1') {
			this._coeducation = '男子校'
		} else if(coeducation == '2') {
			this._coeducation = '女子校'
		} else if(coeducation == '3') {
			this._coeducation = '共学'
		} else if(coeducation == '4') {
			this._coeducation = '男子校 (2026年度から共学)'
		}
		this._targetAge = $e.data('target-age');
		this._access = $e.data('access');
		this._numberOfStudent = $e.data('number-of-student');
		this._numberOfDormitoryStudent = $e.data('number-of-dormitory-student');
		this._internationalStudentPercentage = $e.data('international-student-percentage');
		this._tuitionFee = $e.data('tuition-fee');
		const curriculum = $e.data('curriculum');
		if(curriculum == '1') {
			this._curriculum = 'Aレベル';
		} else if(curriculum == '2') {
			this._curriculum = 'IBDP';
		} else if(curriculum == '3') {
			this._curriculum = 'Aレベル & IBDP';
		} else if(curriculum == '4') {
			this._curriculum = 'n/a';
		}
		this._heading = $e.data('title');
		this._body = $e.data('body');
		this._url = 'https://' + $e.data('url');
		this._email = 'mailto:' + $e.data('email');
		$e.on('click', () => this.modalOpen());
		this._$target.on('click', () => this.modalClose());
		this._$target.find('[data-dismiss=modal]').on('click', () => this.modalClose());
		this._$target.find('.modal__dialog').on('click', () => this.modalClose());
		this._$target.find('.modal__dialog__content').on('click', () => this.modalClose());
		this._$target.find('.modal__dialog__content__header').on('click', (e) => {
			e.preventDefault;
			e.stopPropagation();
		});
		this._$target.find('.modal__dialog__content__body').on('click', (e) => {
			e.preventDefault;
			e.stopPropagation();
		});
		this._$target.find('.modal__dialog__content__footer').on('click', (e) => {
			e.preventDefault;
			e.stopPropagation();
		});
		$('.modal-bg').on('click', () => {
			$('.modal-bg').remove();
		});
	};


	/**
	 * モーダルを開く
	 *
	 * @memberof Modal
	 * @return undefined
	 */
	modalOpen() {
		console.log(`${this.constructor.name}.modalOpen`);
		$('body').css('overflow', 'hidden');
		$('#modal-logo').attr('src', this._logoUrl);
		$('#modal-url-sp').attr('srcset', this._imageUrlSp);
		$('#modal-url-pc').attr('src', this._imageUrlPc);
		$('#modal-url-pc').attr('alt', this._nameEn);
		$('#school-name-ja').text(this._nameJa);
		$('#school-name-en').text(this._nameEn);
		$('#address').text(this._address);
		$('#establishment').text(this._establishment);
		$('#coeducation').text(this._coeducation);
		$('#target-age').text(this._targetAge);
		$('#access').text(this._access);
		$('#number-of-student').text(this._numberOfStudent);
		$('#number-of-dormitory-student').text(this._numberOfDormitoryStudent);
		$('#international-student-percentage').text(this._internationalStudentPercentage);
		$('#tuition-fee').text(this._tuitionFee);
		$('#curriculum').text(this._curriculum);
		$('#heading').html(this._heading);
		$('#body').text(this._body);
		$('#url').attr('href', this._url);
		$('#email').attr('href', this._email);
 		this._$target.addClass('show');
		$('body').append('<div class="modal-bg"></div>');
	};


	/**
	 * モーダルを閉じる
	 *
	 * @memberof Modal
	 * @return undefined
	 */
	modalClose() {
		console.log(`${this.constructor.name}.modalClose`);
		$('body').removeAttr('style');
		$('.modal-bg').remove();
		this._$target.removeClass('show');
	};
};
